import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MdcDialogService } from '../dialog/mdc-dialog.service';
import { FileUploadDialogComponent } from './file-upload-dialog.component';
import { FileUploadDialog, FileUploadDialogData, FileUploadDialogResult } from '@mode/shared/contract-common';

@Injectable()
export class FileUploadDialogService implements FileUploadDialog {
  readonly MODAL_ID = 'mode-file-upload-dialog';

  constructor(private dialogService: MdcDialogService) {}

  close(): void {
    const dialogRef = this.dialogService.getDialogById(this.MODAL_ID);
    if (dialogRef) {
      dialogRef.close();
    }
  }

  open(
    data: FileUploadDialogData,
    uploaderFn: (files: File[]) => Observable<any>
  ): MatDialogRef<FileUploadDialogComponent, FileUploadDialogResult> | any {
    const dialogRef = this.dialogService.open({
      component: FileUploadDialogComponent,
      matDialogConfig: {
        id: this.MODAL_ID,
        width: '716px',
        minHeight: '480px',
        disableClose: true,
        data: data,
      },
    });

    dialogRef.componentInstance.uploadClicked.subscribe((files: File[]) => {
      dialogRef.disableClose = true;

      uploaderFn(files)
        .pipe(
          finalize(() => {
            dialogRef.disableClose = false;
          })
        )
        .subscribe({
          next: () => {
            dialogRef.componentInstance.stopUploading();
            dialogRef.close();
          },
          error: (err) => {
            const msg = err?.message || 'Upload failed';
            const statusCode = err?.status;
            dialogRef.componentInstance.showError(msg, statusCode);
          },
        });
    });

    return dialogRef;
  }
}
